// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__32mY-","signatureBlock":"Footer_signatureBlock__15Arm","signature":"Footer_signature__3iczR"};